module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/attachmentpoints/attachmentpoints-list/attachmentpoints-list.component.css
// module id = ./src/app/attachmentpoints/attachmentpoints-list/attachmentpoints-list.component.css
// module chunks = main